export default {
  hero: {
    breadcrumbs: {
      home: 'Главная',
      properties: 'Объекты'
    }
  },
  property: {
    title: 'Заголовок',
    description: 'Описание',
    price: 'Цена',
    price_currency: 'Валюта',
    gross_area: 'Общая площадь',
    net_area: 'Жилая площадь',
    floor: 'Этаж',
    total_floors: 'Этажей всего',
    rooms: 'Количество комнат',
    layout_type: 'Тип планировки',
    status: 'Статус объекта',
    purpose: 'Назначение',
    ownership: 'Право собственности',
    heating: 'Тип отопления',
    orientation: 'Ориентация',
    view: 'Вид из окна',
    address: 'Адрес',
    year_of_construction: 'Год постройки',
    location: 'Локация',
    video: 'Видеообзор',
    features: 'Характеристики',
    contact_agent: 'Связаться с агентом',
    request_price: 'Уточнить цену и наличие',
    back_to_all: '← Назад ко всем объектам',
    developer: 'Застройщик',
    residential_complex: 'Жилой комплекс',
    building: 'Здание',
    ai_prediction: 'Оценка от ИИ',
    evaluation_chart: 'График оценки',
    map: 'Карта',
    gallery: 'Галерея',
    video_tour: 'Видео-тур',
    loading: 'Загрузка данных квартиры...',
    catalog_id: 'Номер в каталоге',
    layout_type_label: 'Тип объекта',
    status_label: 'Статус',
    purpose_label: 'Назначение',
    heating_label: 'Отопление',
    orientation_label: 'Ориентация',
    building_type_label: 'Тип здания',
    view_label: 'Вид',
    citizenship_available: 'Подходит для гражданства',
    mortgage_available: 'Ипотека доступна',
    not_specified: 'Не указано',

    // Из PropertyCharacteristics
    country: 'Страна',
    region: 'Регион',
    city: 'Город',
    district: 'Район',
    residential_complex_label: 'Жилой комплекс',
    building_label: 'Здание',
    rooms_label: 'Количество комнат',
    floor_label: 'Этаж',
    total_floors_label: 'Этажей в здании',
    gross_area_label: 'Общая площадь',
    net_area_label: 'Жилая площадь',
    year_of_construction_label: 'Год постройки',
    heating_label_fallback: 'Отопление',
    orientation_label_fallback: 'Ориентация',
    building_type_label_fallback: 'Тип здания',
    view_label_fallback: 'Вид из окна',

    gallery_title: 'Фотографии объекта',

    agent: {
      full_name: 'Агент',
      agency: 'Агентство',
      phone: 'Телефон'
    },

    amenities: {
      title: 'Удобства',
      empty: 'Удобства не указаны'
    },

    characteristics: {
      title: 'Характеристики',
      loading: 'Загрузка характеристик...'
    },

    video: {
      no_video: 'Видео отсутствует'
    },

    unpublished: {
      title: 'Объект не опубликован',
      message: 'Квартира недоступна для публичного просмотра.',
      location: 'Локация',
      home: 'На главную'
    },
    not_found: {
      title: 'Объект не найден',
      message: 'К сожалению, запрашиваемая квартира отсутствует или была удалена.',
      back: 'Вернуться к списку объектов'
    }
  }
}
